const transferRates = {
  extras: [
    {
      code: "BOOSTER_SEAT",
      price: 0,
    },
    {
      code: "BABY_TROLLEY",
      price: 0,
    },
    {
      code: "MAXI_COSI",
      price: 0,
    },
    {
      code: "BABY_SEAT",
      price: 0,
    },
    {
      code: "BICYCLE",
      price: 400,
    },
    {
      code: "GOLF_SET",
      price: 400,
    },
  ],
  cities: [
    {
      slug: "alaro",
      oneToFour: 6000,
      fiveToEight: 9500,
      nineToTwelve: 11000,
    },
    // ALCUDIA
    {
      slug: "alcudia",
      oneToFour: 7500,
      fiveToEight: 10000,
      nineToTwelve: 12000,
    },
    {
      slug: "puerto-de-alcudia",
      oneToFour: 7500,
      fiveToEight: 10000,
      nineToTwelve: 12000,
    },
    {
      slug: "port-dalcudia",
      oneToFour: 7500,
      fiveToEight: 10000,
      nineToTwelve: 12000,
    },
    {
      slug: "alcanada",
      oneToFour: 7500,
      fiveToEight: 10000,
      nineToTwelve: 12000,
    },
    {
      slug: "alcanada-alcudia",
      oneToFour: 7500,
      fiveToEight: 10000,
      nineToTwelve: 12000,
    },
    {
      slug: "alcudia-alcanada",
      oneToFour: 7500,
      fiveToEight: 10000,
      nineToTwelve: 12000,
    },
    {
      slug: "alcudia-bon-aire",
      oneToFour: 7500,
      fiveToEight: 10000,
      nineToTwelve: 12000,
    },
    {
      slug: "cielo-de-bonaire-alcudia",
      oneToFour: 7500,
      fiveToEight: 10000,
      nineToTwelve: 12000,
    },
    {
      slug: "alcudia-cielo-de-bonaire",
      oneToFour: 7500,
      fiveToEight: 10000,
      nineToTwelve: 12000,
    },
    {
      slug: "mal-pas-bon-aire-alcudia",
      oneToFour: 7500,
      fiveToEight: 10000,
      nineToTwelve: 12000,
    },
    {
      slug: "es-barcares-alcudia",
      oneToFour: 7500,
      fiveToEight: 10000,
      nineToTwelve: 12000,
    },
    {
      slug: "alcudia-es-barcares",
      oneToFour: 7500,
      fiveToEight: 10000,
      nineToTwelve: 12000,
    },
    {
      slug: "manresa-alcudia",
      oneToFour: 7500,
      fiveToEight: 10000,
      nineToTwelve: 12000,
    },
    {
      slug: "sa-marina-alcudia",
      oneToFour: 7500,
      fiveToEight: 10000,
      nineToTwelve: 12000,
    },
    {
      slug: "alcudia-sa-marina",
      oneToFour: 7500,
      fiveToEight: 10000,
      nineToTwelve: 12000,
    },
    // ALGAIDA
    {
      slug: "algaida",
      oneToFour: 5000,
      fiveToEight: 7500,
      nineToTwelve: 9000,
    },
    // ANDRATX
    {
      slug: "andratx",
      oneToFour: 7000,
      fiveToEight: 9500,
      nineToTwelve: 10500,
    },
    {
      slug: "ariany",
      oneToFour: 7500,
      fiveToEight: 10500,
      nineToTwelve: 11500,
    },
    // ARTA
    {
      slug: "arta",
      oneToFour: 9000,
      fiveToEight: 11000,
      nineToTwelve: 13000,
    },
    {
      slug: "colonia-de-sant-pere",
      oneToFour: 10000,
      fiveToEight: 12000,
      nineToTwelve: 13500,
    },
    {
      slug: "colonia-de-sant-pere-arta",
      oneToFour: 10000,
      fiveToEight: 12000,
      nineToTwelve: 13500,
    },
    // BANYALBUFAR
    {
      slug: "banyalbufar",
      oneToFour: 7000,
      fiveToEight: 11000,
      nineToTwelve: 13000,
    },
    {
      slug: "binissalem",
      oneToFour: 5500,
      fiveToEight: 9000,
      nineToTwelve: 10000,
    },
    {
      slug: "buger",
      oneToFour: 6500,
      fiveToEight: 9000,
      nineToTwelve: 10000,
    },
    {
      slug: "bunyola",
      oneToFour: 4500,
      fiveToEight: 8000,
      nineToTwelve: 9500,
    },
    // CALVIA
    {
      slug: "calvia",
      oneToFour: 6000,
      fiveToEight: 10500,
      nineToTwelve: 11500,
    },
    {
      slug: "santa-ponca",
      oneToFour: 5500,
      fiveToEight: 7000,
      nineToTwelve: 8500,
    },
    {
      slug: "santa-ponca-calvia",
      oneToFour: 5500,
      fiveToEight: 7000,
      nineToTwelve: 8500,
    },
    {
      slug: "santa-ponsa",
      oneToFour: 5500,
      fiveToEight: 7000,
      nineToTwelve: 8500,
    },
    // CAMPANET
    {
      slug: "campanet",
      oneToFour: 7000,
      fiveToEight: 10000,
      nineToTwelve: 12000,
    },
    // CAMPOS
    {
      slug: "campos",
      oneToFour: 6000,
      fiveToEight: 8000,
      nineToTwelve: 9500,
    },
    // CAPDEPERA
    {
      slug: "capdepera",
      oneToFour: 10000,
      fiveToEight: 12000,
      nineToTwelve: 13500,
    },
    {
      slug: "consell",
      oneToFour: 5500,
      fiveToEight: 9500,
      nineToTwelve: 10500,
    },
    {
      slug: "costitx",
      oneToFour: 7500,
      fiveToEight: 11500,
      nineToTwelve: 12500,
    },
    {
      slug: "deia",
      oneToFour: 6500,
      fiveToEight: 8500,
      nineToTwelve: 10000,
    },
    {
      slug: "escorca",
      oneToFour: 9000,
      fiveToEight: 13000,
      nineToTwelve: 14500,
    },
    {
      slug: "esporles",
      oneToFour: 4000,
      fiveToEight: 5500,
      nineToTwelve: 7000,
    },
    {
      slug: "estellencs",
      oneToFour: 7000,
      fiveToEight: 9000,
      nineToTwelve: 10500,
    },
    // FELANITX
    {
      slug: "felanitx",
      oneToFour: 7000,
      fiveToEight: 9000,
      nineToTwelve: 10500,
    },
    {
      slug: "portocolom-felanitx",
      oneToFour: 8000,
      fiveToEight: 11000,
      nineToTwelve: 12500,
    },
    {
      slug: "portocolom",
      oneToFour: 8000,
      fiveToEight: 11000,
      nineToTwelve: 12500,
    },
    // FORNALUTX
    {
      slug: "fornalutx",
      oneToFour: 7000,
      fiveToEight: 11000,
      nineToTwelve: 12500,
    },
    {
      slug: "inca",
      oneToFour: 5500,
      fiveToEight: 7500,
      nineToTwelve: 9000,
    },
    {
      slug: "lloret-de-vistalegre",
      oneToFour: 6000,
      fiveToEight: 10000,
      nineToTwelve: 11000,
    },
    {
      slug: "lloseta",
      oneToFour: 6500,
      fiveToEight: 9500,
      nineToTwelve: 10500,
    },
    {
      slug: "llubi",
      oneToFour: 7000,
      fiveToEight: 11000,
      nineToTwelve: 12000,
    },
    // LLUCMAJOR
    {
      slug: "llucmajor",
      oneToFour: 4000,
      fiveToEight: 6000,
      nineToTwelve: 7500,
    },
    {
      slug: "cala-blava",
      oneToFour: 4000,
      fiveToEight: 6000,
      nineToTwelve: 7500,
    },
    {
      slug: "cala-blava-llucmajor",
      oneToFour: 4000,
      fiveToEight: 6000,
      nineToTwelve: 7500,
    },
    // MANACOR
    {
      slug: "manacor",
      oneToFour: 7000,
      fiveToEight: 10000,
      nineToTwelve: 12000,
    },
    {
      slug: "manacor-porto-cristo",
      oneToFour: 8000,
      fiveToEight: 11000,
      nineToTwelve: 12000,
    },
    {
      slug: "porto-cristo-manacor",
      oneToFour: 8000,
      fiveToEight: 11000,
      nineToTwelve: 12000,
    },
    // MANCOR DE LA VALL
    {
      slug: "mancor-de-la-vall",
      oneToFour: 7000,
      fiveToEight: 11000,
      nineToTwelve: 12000,
    },
    {
      slug: "maria-de-la-salut",
      oneToFour: 8000,
      fiveToEight: 11000,
      nineToTwelve: 12000,
    },
    {
      slug: "marratxi",
      oneToFour: 4500,
      fiveToEight: 8000,
      nineToTwelve: 9000,
    },
    {
      slug: "montuiri",
      oneToFour: 6500,
      fiveToEight: 10500,
      nineToTwelve: 12000,
    },
    // MURO
    {
      slug: "muro",
      oneToFour: 8500,
      fiveToEight: 11000,
      nineToTwelve: 12000,
    },
    {
      slug: "playa-de-muro",
      oneToFour: 7500,
      fiveToEight: 10000,
      nineToTwelve: 12000,
    },
    {
      slug: "muro-platja-de-muro",
      oneToFour: 7500,
      fiveToEight: 10000,
      nineToTwelve: 12000,
    },
    // PALMA
    {
      slug: "palma-de-mallorca",
      oneToFour: 4000,
      fiveToEight: 6500,
      nineToTwelve: 8500,
    },
    {
      slug: "palma",
      oneToFour: 4000,
      fiveToEight: 6500,
      nineToTwelve: 8500,
    },
    // PETRA
    {
      slug: "petra",
      oneToFour: 7000,
      fiveToEight: 11000,
      nineToTwelve: 12000,
    },
    // POLLENÇA
    {
      slug: "pollensa",
      oneToFour: 7500,
      fiveToEight: 10000,
      nineToTwelve: 12000,
    },
    {
      slug: "pollenca",
      oneToFour: 7500,
      fiveToEight: 10000,
      nineToTwelve: 12000,
    },
    {
      slug: "puerto-de-pollensa",
      oneToFour: 7500,
      fiveToEight: 10000,
      nineToTwelve: 12000,
    },
    {
      slug: "port-de-pollenca",
      oneToFour: 7500,
      fiveToEight: 10000,
      nineToTwelve: 12000,
    },
    {
      slug: "formentor",
      oneToFour: 7500,
      fiveToEight: 10000,
      nineToTwelve: 12000,
    },
    {
      slug: "formentor-pollensa",
      oneToFour: 7500,
      fiveToEight: 10000,
      nineToTwelve: 12000,
    },
    {
      slug: "pollenca-formentor",
      oneToFour: 7500,
      fiveToEight: 10000,
      nineToTwelve: 12000,
    },
    {
      slug: "cala-sant-vicenc",
      oneToFour: 7500,
      fiveToEight: 10000,
      nineToTwelve: 12000,
    },
    {
      slug: "cala-sant-vicenc-pollensa",
      oneToFour: 7500,
      fiveToEight: 10000,
      nineToTwelve: 12000,
    },
    // PORRERES
    {
      slug: "porreres",
      oneToFour: 6000,
      fiveToEight: 8000,
      nineToTwelve: 10500,
    },
    {
      slug: "puigpunyent",
      oneToFour: 6000,
      fiveToEight: 11000,
      nineToTwelve: 12000,
    },
    {
      slug: "sa-pobla",
      oneToFour: 6500,
      fiveToEight: 9000,
      nineToTwelve: 10500,
    },
    {
      slug: "sa-pobla-crestatx",
      oneToFour: 7000,
      fiveToEight: 9500,
      nineToTwelve: 11000,
    },
    {
      slug: "crestatx-sa-pobla",
      oneToFour: 7000,
      fiveToEight: 9500,
      nineToTwelve: 11000,
    },
    {
      slug: "sant-joan",
      oneToFour: 6000,
      fiveToEight: 8500,
      nineToTwelve: 10000,
    },
    // SANT LLORENÇ DES CARDASSAR
    {
      slug: "sant-llorenc-des-cardassar",
      oneToFour: 8500,
      fiveToEight: 11000,
      nineToTwelve: 12000,
    },
    {
      slug: "sant-llorens-des-cardassar",
      oneToFour: 8500,
      fiveToEight: 11000,
      nineToTwelve: 12000,
    },
    {
      slug: "sa-coma",
      oneToFour: 8500,
      fiveToEight: 11000,
      nineToTwelve: 12500,
    },
    {
      slug: "sa-coma-sant-llorenc-des-cardassar",
      oneToFour: 8500,
      fiveToEight: 11000,
      nineToTwelve: 12500,
    },
    // SANTA EUGÈNIA
    {
      slug: "santa-eugenia",
      oneToFour: 4500,
      fiveToEight: 6500,
      nineToTwelve: 8000,
    },
    // SANTA MARGALIDA
    {
      slug: "santa-margalida",
      oneToFour: 7500,
      fiveToEight: 10000,
      nineToTwelve: 12000,
    },
    {
      slug: "can-picafort",
      oneToFour: 7500,
      fiveToEight: 10000,
      nineToTwelve: 12000,
    },
    {
      slug: "can-picafort-santa-margalida",
      oneToFour: 7500,
      fiveToEight: 10000,
      nineToTwelve: 12000,
    },
    {
      slug: "son-serra-de-marina",
      oneToFour: 9000,
      fiveToEight: 12500,
      nineToTwelve: 14000,
    },
    {
      slug: "son-serra-de-marina-santa-margalida",
      oneToFour: 9000,
      fiveToEight: 12500,
      nineToTwelve: 14000,
    },
    // SANTA MARIA
    {
      slug: "santa-maria",
      oneToFour: 4000,
      fiveToEight: 6500,
      nineToTwelve: 8000,
    },
    {
      slug: "santa-maria-del-cami",
      oneToFour: 4000,
      fiveToEight: 6500,
      nineToTwelve: 8000,
    },
    {
      slug: "santanyi",
      oneToFour: 8000,
      fiveToEight: 11000,
      nineToTwelve: 12000,
    },
    // SELVA
    {
      slug: "selva",
      oneToFour: 6000,
      fiveToEight: 10500,
      nineToTwelve: 12000,
    },
    {
      slug: "moscari",
      oneToFour: 6500,
      fiveToEight: 9500,
      nineToTwelve: 10500,
    },
    {
      slug: "moscari-selva",
      oneToFour: 6500,
      fiveToEight: 9500,
      nineToTwelve: 10500,
    },
    {
      slug: "caimari",
      oneToFour: 6500,
      fiveToEight: 10000,
      nineToTwelve: 11000,
    },
    {
      slug: "caimari-selva",
      oneToFour: 6500,
      fiveToEight: 10000,
      nineToTwelve: 11000,
    },
    {
      slug: "biniamar",
      oneToFour: 6500,
      fiveToEight: 10000,
      nineToTwelve: 11000,
    },
    {
      slug: "biniamar-selva",
      oneToFour: 6500,
      fiveToEight: 10000,
      nineToTwelve: 11000,
    },
    // SENCELLES
    {
      slug: "sencelles",
      oneToFour: 5500,
      fiveToEight: 9500,
      nineToTwelve: 11000,
    },
    // SES SALINES
    {
      slug: "ses-salines",
      oneToFour: 6500,
      fiveToEight: 9000,
      nineToTwelve: 10500,
    },
    {
      slug: "colonia-de-sant-jordi",
      oneToFour: 6500,
      fiveToEight: 9000,
      nineToTwelve: 10500,
    },
    {
      slug: "colonia-de-sant-jordi-ses-salines",
      oneToFour: 6500,
      fiveToEight: 9000,
      nineToTwelve: 10500,
    },
    // SINEU
    {
      slug: "sineu",
      oneToFour: 7000,
      fiveToEight: 9000,
      nineToTwelve: 10500,
    },
    {
      slug: "soller",
      oneToFour: 6500,
      fiveToEight: 11000,
      nineToTwelve: 12500,
    },
    {
      slug: "son-servera",
      oneToFour: 8500,
      fiveToEight: 11000,
      nineToTwelve: 12500,
    },
    {
      slug: "valldemossa",
      oneToFour: 5500,
      fiveToEight: 7500,
      nineToTwelve: 9000,
    },
    {
      slug: "vilafranca-de-bonany",
      oneToFour: 6000,
      fiveToEight: 8000,
      nineToTwelve: 9500,
    },
  ],
  areas: [
    {
      name: "north",
      oneToFour: 7500,
      fiveToEight: 10000,
      nineToTwelve: 12000,
    },
    {
      name: "south",
      oneToFour: 7500,
      fiveToEight: 10000,
      nineToTwelve: 12000,
    },
    {
      name: "east",
      oneToFour: 7500,
      fiveToEight: 10000,
      nineToTwelve: 12000,
    },
    {
      name: "west",
      oneToFour: 7500,
      fiveToEight: 10000,
      nineToTwelve: 12000,
    },
    {
      name: "center",
      oneToFour: 7500,
      fiveToEight: 10000,
      nineToTwelve: 12000,
    },
  ],
  base: {
    oneToFour: 10000,
    fiveToEight: 13000,
    nineToTwelve: 14500,
  },
};

export default transferRates;
